import { useMutation } from '@tanstack/react-query';
import httpClient from 'axios-settings/http-client';
import { sanitizeFilename } from 'helpers/files';

export default function useRemoteFileUploadMutation() {
  return useMutation({
    mutationKey: ['remoteFileUpload'],
    mutationFn: async ({ file, uploadResponse }) => {
      const filename = sanitizeFilename(file.name);
      const formData = new FormData();
      const { attributes } = uploadResponse.data;
      attributes.key = attributes.key.replace('${filename}', filename);

      Object.entries(attributes).forEach((entry) =>
        formData.append(entry[0], entry[1]),
      );
      formData.append('file', file);

      httpClient.defaults.headers.common.Accept = 'application/xml';
      httpClient.defaults.headers.common['Content-Type'] =
        'multipart/form-data';
      httpClient.defaults.headers.common['X-Content-Type-Options'] = 'nosniff';
      httpClient.defaults.headers.common['Cache-Control'] =
        'no-cache, no-store, max-age=0, must-revalidate';
      httpClient.defaults.headers.common.Pragma = 'no-cache';

      const uploadResult = await httpClient.post(
        uploadResponse.links.uploadUrl,
        formData,
      );

      const xmlDoc = uploadResult.request.responseXML;
      const uploadKey = xmlDoc.getElementsByTagName('Key')[0].textContent;

      return uploadKey;
    },
  });
}
